import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var RefreshCcw01 = function RefreshCcw01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M2 10s2.005-2.7318 3.6338-4.3618S9.5136 3 12 3c4.9706 0 9 4.0294 9 9s-4.0294 9-9 9c-4.103 0-7.5649-2.7457-8.6482-6.5M2 10V4m0 6h6"
    })
  }));
};
export default RefreshCcw01;